if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton?.querySelector('span');

      if (document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      // Hide Shopify's dynamic checkout buttons and inject our own
      this.injectBuyNowButton();
    }

    injectBuyNowButton() {
      // Hide the native dynamic checkout buttons (iframe-based, uncontrollable)
      const dynamicCheckout = this.querySelector('.shopify-payment-button');
      if (dynamicCheckout) dynamicCheckout.style.display = 'none';

      // Create our own Buy Now button
      const buyNowBtn = document.createElement('button');
      buyNowBtn.type = 'button';
      buyNowBtn.id = 'custom-buy-now-btn';
      buyNowBtn.textContent = 'Buy it now';
      buyNowBtn.style.cssText = `
        width: 100%;
        padding: 1.2rem;
        margin-top: 0.8rem;
        background-color: var(--color-button, #c9a96e);
        color: var(--color-button-text, #ffffff);
        border: 1px solid var(--color-button, #c9a96e);
        font-size: 1.4rem;
        font-family: inherit;
        letter-spacing: 0.1rem;
        cursor: pointer;
        transition: opacity 0.2s;
      `;

      buyNowBtn.addEventListener('mouseenter', () => buyNowBtn.style.opacity = '0.85');
      buyNowBtn.addEventListener('mouseleave', () => buyNowBtn.style.opacity = '1');
      buyNowBtn.addEventListener('click', this.onBuyNowHandler.bind(this));

      // Insert after the submit button's parent or after the form
      const insertTarget = dynamicCheckout || this.submitButton?.closest('.product-form__buttons');
      if (insertTarget) {
        insertTarget.insertAdjacentElement('afterend', buyNowBtn);
      } else {
        this.form.insertAdjacentElement('afterend', buyNowBtn);
      }
    }

    onBuyNowHandler(evt) {
      evt.preventDefault();
      const quantity = this.getQuantity();
      const variantId = this.form.querySelector('[name="id"]')?.value;
      if (!variantId) return;

      const btn = document.getElementById('custom-buy-now-btn');
      if (btn) { btn.textContent = 'Loading...'; btn.disabled = true; }

      fetch('/cart/clear.js', { method: 'POST' })
        .then(() => fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        }))
        .then(() => { window.location.href = '/checkout'; })
        .catch((e) => {
          console.error(e);
          window.location.href = `/cart/${variantId}:${quantity}`;
        })
        .finally(() => {
          if (btn) { btn.textContent = 'Buy it now'; btn.disabled = false; }
        });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.classList.add('loading');
      this.querySelector('.loading__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const quantity = this.getQuantity();
      formData.set('quantity', quantity);

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', 'true');
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response); });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => { console.error(e); })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
          this.submitButton.removeAttribute('aria-disabled');
        });
    }

    getQuantity() {
      const scope = this.closest('section') || this.closest('.product') || document;
      const quantityInput =
        scope.querySelector('input.quantity__input') ||
        scope.querySelector('quantity-input input') ||
        scope.querySelector('[name="quantity"]') ||
        this.form.querySelector('[name="quantity"]');
      return quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) { this.errorMessage.textContent = errorMessage; }
    }
  });
}
